/**
 * Double Check Icon
 *
 * Used for verification success states.
 */

import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

export interface DoubleCheckIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

interface DoubleCheckIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  checkColor?: string;
  autoAnimate?: boolean;
}

const DoubleCheckIcon = forwardRef<DoubleCheckIconHandle, DoubleCheckIconProps>(
  ({ className, size = 28, ...props }, _ref) => {
    return (
      <div
        className={className}
        {...props}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          height={size}
          width={size}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m3 12 4 4 8-8" />
          <path d="m11 12 4 4 8-8" />
        </svg>
      </div>
    );
  }
);

DoubleCheckIcon.displayName = "DoubleCheckIcon";

export { DoubleCheckIcon };
